import axios from "axios";
import { AddMessagesRequest } from "../../../api-types/job-requests/common";
import { addBidMessageUrl } from "../../utils";

export const addBidMessage = (bidId: string, request: AddMessagesRequest) => {
  return axios.post(addBidMessageUrl(bidId), request);
};
